import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()
    const {canFold, canUnfold, foldNode, unfoldNode} = map.commands

    const item = {
        key: 'toggle-fold-node',
        suffix: 'Ctrl+/',
    }

    const nodesCanFold = canFold(selectedNodes)

    if (0 < nodesCanFold.length) {
        return {
            ...item,
            label: '折叠子节点',
            onClick: () => foldNode(nodesCanFold),
        }
    }

    const nodesCanUnfold = canUnfold(selectedNodes)

    if (0 < nodesCanUnfold.length) {
        return {
            ...item,
            label: '展开子节点',
            onClick: () => unfoldNode(nodesCanUnfold),
        }
    }

    return {
        ...item,
        disabled: true,
        label: '折叠子节点',
    }
}
